import React from 'react';
import Form from "react-bootstrap/Form";
import MemberTypeItemNames from "./MemberTypeItemNames";

const MembersInfo = ({fields, handleFieldChange, memStatus, memType, memClass, memPost, memCommittee, memRepresentative, messages, page}) => {
  const memStatusItems = [
      '',
      '申込',
      '仮入会',
      '審査中',
      '登録完了'
  ];

  const memTypeItems = [
      '',
      '正会員',
      '准会員',
      '正会員（准会員より移行）',
      '名誉会員'
  ];

  const memClassItems = [
      '',
      '現在会員',
      '退会',
      '退会（物故）',
      '退会（除名）'
  ];

  const memPostItems = [
      '理事長',
      '副理事長',
      '理事',
      '監事',
      '委員長'
  ];

  const memCommitteeItems = [
      '総務委員会',
      '財務委員会',
      '学術委員会',
      '編集委員会',
      '教育研修委員会',
      '資格審査委員会',
      '倫理・COI委員会',
      'オリンピック・パラリンピック等準備委員会',
      '国際委員会',
      '広報委員会'
  ];

  const memRepresentativeItems = [
      '代議員'
  ];

  const getSelectedItems = (items, labels) => {
    if (!items) return "";
    let arr = [];
    for (let i = 0; i < items.length; i++) {
	if (0 != items[i]) arr.push(labels[i]);
    }
    return arr.join();
  };

  return (
    <>
      <h2>会員情報</h2>
      <dl>
        <dt>会員番号</dt>
        <dd>
          { fields.loginId }&emsp;
        </dd>
        <dt>入会日</dt>
        <dd>
          { fields.admissionDate }&emsp;
        </dd>
        <dt className={memType == 3 || memType == 6 || memType == 16 ? 'hiddenRow' : ''}>状態</dt>
        <dd className={memType == 3 || memType == 6 || memType == 16 ? 'hiddenRow' : ''}>
          { memStatusItems[memStatus] }&emsp;
        </dd>
        <dt className={memType == 6 || memType == 16 ? 'hiddenRow' : ''}>会員種別</dt>
        <dd className={memType == 6 || memType == 16 ? 'hiddenRow' : ''}>
          { MemberTypeItemNames[memType] }&emsp;
        </dd>
        <dt className={memType == 6 || memType == 16 ? 'hiddenRow' : ''}>会員区分</dt>
        <dd className={memType == 6 || memType == 16 ? 'hiddenRow' : ''}>
          { memClassItems[memClass] } &emsp;
        </dd>
        <dt className={memType == 6 || memType == 16 ? 'hiddenRow' : ''}>役職</dt>
        <dd className={memType == 6 || memType == 16 ? 'hiddenRow' : ''}>
          { getSelectedItems(memPost, memPostItems) }&emsp;
        </dd>
        <dt className={memType == 6 || memType == 16 ? 'hiddenRow' : ''}>委員会</dt>
        <dd className={memType == 6 || memType == 16 ? 'hiddenRow' : ''}>
          { getSelectedItems(memCommittee, memCommitteeItems) }&emsp;
        </dd>
        <dt className={memType == 6 || memType == 16 ? 'hiddenRow' : ''}>代議員</dt>
        <dd className={memType == 6 || memType == 16 ? 'hiddenRow' : ''}>
          { getSelectedItems(memRepresentative, memRepresentativeItems) }&emsp;
        </dd>
        <dt className={memType == 6 || memType == 16 ? 'hiddenRow' : ''}>理事任期</dt>
        <dd className={memType == 6 || memType == 16 ? 'hiddenRow' : ''}>
         { fields.termOfDirective } &emsp;
        </dd>
        <dt className={memType == 3 || memType == 6 || memType == 16 ? 'hiddenRow' : ''}>准会員より正会員への変更日</dt>
        <dd className={memType == 3 || memType == 6 || memType == 16 ? 'hiddenRow' : ''}>
          { fields.transitionDate }&emsp;
        </dd>
      </dl>
    </>
  );
}

export default MembersInfo;
